export const CXENTRY_BARCODE_SCAN_MESSAGE = 'cxentry:barcode-scan' as const;
